export default __webpack_public_path__ + "images/bad78f4977ac442822cf11dd1d1095a7.png";